import React from 'react';
import PropTypes from 'prop-types';

import { ArrowRightCircle, Rectangles } from '../Icons';
import HonoreeCard from '../HonoreeCard';
import { CDN_URL } from '../../constants';

const EventSlideLarge = ({ cta, description, handleNext, honorees, title }) => {
  if (!title) {
    return null;
  }

  const hasHonorees = !!honorees?.length;

  return (
    <div className='event-slide-large'>
      <div className='event-slide-large__container'>
        <div className='event-slide-large__main'>
          <div className='event-slide-large__header'>
            <Rectangles className='event-slide-large__icon-rectangles' />
            <div className='event-slide-large__title'>{title}</div>
          </div>
          {description && (
            <div
              className='event-slide-large__description'
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}

          <div
            className='event-slide-large__image'
            style={{ backgroundImage: `url(${CDN_URL}/assets/images/image-10.jpg` }}
          />
        </div>
        <div className='event-slide-large__side'>
          {hasHonorees && (
            <>
              <div className='event-slide-large__subtitle'>Honoring</div>
              <div className='event-slide-large__honorees'>
                <ul className='event-slide-large__honorees-list'>
                  {honorees.map((item, index) => {
                    return (
                      <li
                        className='event-slide-large__honorees-list-item'
                        key={`event-slide-large__honorees-list-item-${index}`}
                      >
                        <HonoreeCard {...item} />
                      </li>
                    );
                  })}
                </ul>
              </div>
            </>
          )}
          <div className='event-slide-large__controls'>
            {cta?.title && cta?.link && (
              <a
                href={cta.link}
                className='event-slide-large__cta event-slide-large__cta-blue'
                rel='noreferrer'
                target='_blank'
              >
                <span className='event-slide-large__cta-title'>{cta?.title}</span>
                <ArrowRightCircle className='event-slide-large__cta-icon' />
              </a>
            )}
            <button
              className='event-slide-large__cta event-slide-large__cta-sky-blue'
              onClick={handleNext}
            >
              <span className='event-slide-large__cta-title'>Past events</span>
              <ArrowRightCircle className='event-slide-large__cta-icon' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

EventSlideLarge.propTypes = {
  cta: PropTypes.object,
  description: PropTypes.string,
  handleNext: PropTypes.func,
  honorees: PropTypes.array,
  title: PropTypes.string,
};

export default EventSlideLarge;
